import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Tenés entre 30 y 50 años y sentís que tu metabolismo frenó', 'Hacés cosas "bien" pero la panza no baja', 'Tenés poco tiempo y necesitás un mapa claro, no teoría', 'Querés verte mejor sin sacrificar la vida que construiste', 'Sos latino viviendo en USA y el ritmo de vida te está pasando factura'];
  const notFor = ['Buscás una pastilla mágica sin cambiar nada', 'Querés marcar abdominales para una competencia', 'No estás dispuesto a seguir un protocolo por 14 días'];
  return <section className="bg-dark-bg text-white py-20 px-4 md:px-8" data-id="element-164">
      <div className="max-w-6xl mx-auto" data-id="element-165">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-166">
          {/* IS FOR */}
          <div className="bg-dark-surface p-8 rounded-xl border-t-4 border-brand-orange shadow-lg" data-id="element-167">
            <h3 className="font-oswald text-2xl md:text-3xl font-bold mb-8 uppercase text-center" data-id="element-168">
              Esto <span className="text-brand-orange" data-id="element-169">SÍ</span> es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-170">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-171">
                  <CheckCircle2 className="w-6 h-6 text-brand-orange mr-4 flex-shrink-0 mt-1" data-id="element-172" />
                  <span className="font-inter text-gray-300 text-lg" data-id="element-173">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* NOT FOR */}
          <div className="bg-dark-surface p-8 rounded-xl border-t-4 border-red-600 shadow-lg" data-id="element-174">
            <h3 className="font-oswald text-2xl md:text-3xl font-bold mb-8 uppercase text-center" data-id="element-175">
              Esto <span className="text-red-500" data-id="element-176">NO</span> es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-177">
              {notFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-178">
                  <XCircle className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-179" />
                  <span className="font-inter text-gray-300 text-lg" data-id="element-180">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}